export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13778.05a31da6.jpg";